import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@evaneos/b2b-ui';
import CloseOutlinedIcon from '@evaneos/b2b-ui/icons/CloseOutlined';
import { useIntl } from 'react-intl';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const AppointmentDisconnectConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
}: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="disconnect-dialog-title"
            slotProps={{ paper: { sx: { padding: 3, maxWidth: 560, borderRadius: 2 } } }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <DialogTitle
                    id="disconnect-dialog-title"
                    variant="h2"
                    sx={{ p: 0, fontWeight: 700 }}
                >
                    {/* @todo translate: agenda.disconnect_dialog.title */}
                    Confirmer votre déconnexion
                </DialogTitle>
                <IconButton onClick={onClose} aria-label={formatMessage({ id: 'global.close' })}>
                    <CloseOutlinedIcon />
                </IconButton>
            </Box>
            <DialogContent sx={{ px: 0 }}>
                <Alert severity="error">
                    {/* @todo translate: agenda.disconnect_dialog.warning */}
                    Déconnecter votre compte Google de l&apos;environnement Evaneos supprimera la
                    possibilité pour vos voyageurs de prendre rendez-vous avec vous.
                </Alert>
            </DialogContent>
            <DialogActions sx={{ px: 0, justifyContent: 'flex-start' }}>
                <Button
                    data-spec-id="agenda-disconnect-confirm-button"
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                >
                    {/* @todo translate: agenda.disconnect_dialog.confirm_button */}
                    Déconnecter mon compte Google
                </Button>
                <Button variant="outlined" onClick={onClose}>
                    {/* @todo translate: form.cancel */}
                    Annuler
                </Button>
            </DialogActions>
        </Dialog>
    );
};
